export default "__VITE_ASSET__B6gjyGg5__"